<template>
	<transition name="modal">
	    <div class="modal-mask">
	      <div class="modal-wrapper">
	        <div class="modal-container" id="update-open-invoices-modal">
	          <div class="modal-header">
              <div class="title-header">
                <i class="fa fa-exclamation-circle float-left"></i>
                <b class="float-left">OUR RECORDS INDICATE THAT YOU HAVE INVOICES THAT ARE PAST DUE</b>
              </div>
	          </div>
	          <div class="modal-body">
                  <update-open-invoices-table :openInvoicesArray="openInvoicesArray" :agreementData="agreementData" @change="value => {selectedAgreements = value}"></update-open-invoices-table>
	          </div>
              <div class="modal-complement">
                <div class="agree-section">
                    <div class="form-group materialized check-label">
                        <el-checkbox v-model="agreeOpenInvoices" @change="uncheckInvoices(agreeOpenInvoices)">
                            <p>I understand that if I do not pay my past balance(s), my club access may be suspended until the balance is paid in full.<br/>If the balance is not paid prior to my next billing cycle, the amount will be included in my electronic dues debit, along with the current month's dues.</p>
                        </el-checkbox>
                    </div>
                </div>
              </div>
	          <div class="modal-footer materialized">
                <section class="button-container">
                    <button class="btn btn-default" @click="$emit('close', [])"
                        :class="{ 'disabled' : !agreeOpenInvoices, 'btn btn-default' : true }" :disabled="!agreeOpenInvoices">Dismiss for Now
                    </button>
                    <button class="btn btn-primary"
                        :class="{ 'disabled' : agreeOpenInvoices, 'btn btn-primary' : true }"
                        :disabled="!(!agreeOpenInvoices && selectedAgreements.length !== 0)"
                        @click="payOpenInvoices()"
                        v-if="agreementData.kindOfPayment === 'card'">
                        <i class="fa fa-cog fa-spin fa-fw margin-bottom security-saving-icon" v-show="isPaying"></i>
                        Pay Now
                    </button>
                    <button class="btn btn-primary"
                        :class="{ 'disabled' : agreeOpenInvoices, 'btn btn-primary': true }"
                        :disabled="agreeOpenInvoices"
                        @click="moveToMakeAPayment()"
                        v-if="agreementData.kindOfPayment === 'bank'">
                        Pay Now
                    </button>
                </section>
	          </div>
	        </div>
	      </div>
	    </div>
	  </transition>
</template>

<script>
  import _ from 'lodash'
  import updateOpenInvoicesTable from './UpdateOpenInvoicesTable.vue'
  import { ServiceContainer } from 'CommonBilling'
  const payInvoicesService = ServiceContainer.payInvoicesService

  export default {
    name: 'UpdateAgreementsModal',
    props: {
      agreementData: {
        type: Object,
        required: true
      },
      openInvoicesArray: {
        type: Array,
        required: true
      },
      creditCardPaymentData: {
        type: Object,
        required: true
      }
    },
    components: {
      'update-open-invoices-table': updateOpenInvoicesTable
    },
    data () {
      return {
        agreeOpenInvoices: false,
        isPaying: false,
        invoicesSelectedToPay: [],
        selectedAgreements: []
      }
    },
    methods: {
      getSelectedAgreementsObject () {
        return _.filter(this.openInvoicesArray, (due) => _.includes(this.selectedAgreements, due.idReferential))
      },
      prepareAgreements () {
        let invoices = []
        const data = this.getSelectedAgreementsObject()
        _.map(data, (invoice) => {
          let invoiceData = {
            referenceNumber: invoice.referenceNumber,
            dueDate: invoice.date
          }
          invoices.push(invoiceData)
        })
        return (invoices)
      },
      uncheckInvoices (value) {
        if (this.agreementData.kindOfPayment === 'card') {
          this.$children[0].selectAll = !value
        }
      },
      moveToMakeAPayment () {
        window.open('billing/#/makeapayment?callAutoPay=false', '_blank')
        this.$emit('close', [])
      },
      payOpenInvoices () {
        this.isPaying = true
        let invoicesSelectedToPay = this.prepareAgreements()
        return payInvoicesService.payInvoices({
          invoicePayments: invoicesSelectedToPay,
          bankInformationDTO: {
            accountNumber: this.creditCardPaymentData.cardNumber,
            accountType: this.creditCardPaymentData.cardType,
            creditCardExpireDate: this.creditCardPaymentData.expirationMonth + '-' + this.creditCardPaymentData.expirationYear,
            nameOnAccount: this.creditCardPaymentData.nameOnCard
          }
        }).then((success) => {
          this.handleSuccessfulPayment()
        }).catch((error) => {
          let errorMsg = ''
          if (error.response !== undefined && error.response.data !== undefined) {
            errorMsg = error.response.data.errorMessage
          } else {
            errorMsg = 'There was an error when trying to make a payment'
          }
          this.$toasted.show(errorMsg,
            {
              theme: 'primary',
              position: 'bottom-center',
              duration: 10000
            },
            function () {})
          this.isPaying = false
        })
      },
      handleSuccessfulPayment () {
        this.isPaying = false
        this.$emit('close', this.getSelectedAgreementsObject())
      }
    }
  }
</script>
<style lang="scss">
  @import '~CommonBilling/css/variables';

  .float-left {
    float: left;
  }
  #update-open-invoices-modal {
    border: solid 2px #EA1929;
    .modal-header {
      background-color: #EA1929;
      border-bottom: 0;
      color: white;
    }
    .title-header {
      i {
        font-size: 33px;
      }
      b {
        padding: 8px 0 0 10px;
      }
    }
    .modal-body {
      margin-top: 0 !important;
    }
    .modal-footer {
      display: flex;
      border: none;
      section {
        &.agreement-message {
          flex: 3;
          p {
            text-align: left;
          }
        }
        &.button-container {
          display: flex;
          flex: 1;
          justify-content: flex-end;
          align-items: center;
          button {
            height: min-content;
            padding-top: 5px;
            padding-bottom: 5px;
            &.btn-primary {
              border: 1px solid #EA1929;
              &.disabled-agree {
                border-color: rgba(234, 25, 41, 0.15);
              }
            }
          }
        }
      }
    }
  }

  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) {
      .button-container {
          margin-top: 90px;
      }
  }

</style>



// WEBPACK FOOTER //
// node_modules/UpdatePaymentMethods/updateOpenInvoices/UpdateOpenInvoicesModal.vue